var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 8.91334C6 8.68314 6.07435 8.49439 6.22306 8.34663C6.33912 8.19888 6.52907 8.125 6.79338 8.125L17.2066 8.125C17.3884 8.125 17.5784 8.19888 17.7769 8.34663C17.9256 8.49439 18 8.68314 18 8.91334C18 9.09398 17.9256 9.25841 17.7769 9.40617L12.5701 14.5795C12.372 14.7768 12.182 14.875 11.9998 14.875C11.8184 14.875 11.628 14.7768 11.4299 14.5795L6.22306 9.40617C6.07435 9.25841 6 9.09398 6 8.91334Z",
  fill: "#4585FF"
})));
export default SvgIconArrow;